export const newsMock = [
    {
        id: 1,
        title: "Lancement d’un programme national de formation",
        summary:
            "La CNTIPPEE lance un programme destiné à renforcer les capacités des acteurs nationaux dans le cadre de la promotion des investissements publics.",
        date: "12 Janvier 2025",
        category: "Actualité",
        author: "CNTIPPEE",
        views: 128,
        image: "/assets/images/news/1.jpg"
    },
    {
        id: 2,
        title: "Atelier de concertation régionale",
        summary:
            "Un atelier de concertation régionale a été organisé afin d’évaluer l’état d’avancement des projets en cours et de recueillir les recommandations des parties prenantes.",
        date: "05 Janvier 2025",
        category: "Événement",
        author: "Direction de la Communication",
        views: 86,
        image: "/assets/images/news/2.jpg"
    },
    {
        id: 3,
        title: "Suivi des projets d’infrastructures prioritaires",
        summary:
            "La CNTIPPEE intensifie le suivi des projets d’infrastructures prioritaires afin de garantir le respect des délais et la qualité des ouvrages.",
        date: "20 Décembre 2024",
        category: "Projet",
        author: "Direction Technique",
        views: 214,
        image: "/assets/images/news/3.jpg"
    },
    {
        id: 4,
        title: "Renforcement de la transparence dans la gestion des investissements",
        summary:
            "De nouvelles mesures ont été mises en place pour améliorer la transparence et la traçabilité des investissements publics financés par l’État.",
        date: "10 Décembre 2024",
        category: "Institutionnel",
        author: "CNTIPPEE",
        views: 172,
        image: "/assets/images/news/2.jpg"
    },
    {
        id: 5,
        title: "Mission de terrain dans les provinces de l’intérieur",
        summary:
            "Une mission de terrain a permis d’évaluer l’état d’avancement de plusieurs projets structurants dans les provinces de l’intérieur du pays.",
        date: "28 Novembre 2024",
        category: "Terrain",
        author: "Cellule de Suivi",
        views: 95,
        image: "/assets/images/news/3.jpg"
    },
    {
        id: 6,
        title: "Partenariat renforcé avec les partenaires techniques et financiers",
        summary:
            "La CNTIPPEE renforce sa collaboration avec les partenaires techniques et financiers afin d’optimiser l’impact des projets d’investissements publics.",
        date: "15 Novembre 2024",
        category: "Partenariat",
        author: "Direction Générale",
        views: 143,
        image: "/assets/images/news/1.jpg"
    },
    {
        id: 7,
        title: "Bilan annuel des projets financés par l’État",
        summary:
            "Présentation du bilan annuel des projets financés par l’État, mettant en évidence les résultats atteints et les perspectives pour l’année à venir.",
        date: "30 Octobre 2024",
        category: "Rapport",
        author: "CNTIPPEE",
        views: 301,
        image: "/assets/images/news/3.jpg"
    },
    {
        id: 8,
        title: "Digitalisation du suivi des investissements publics",
        summary:
            "La CNTIPPEE amorce une nouvelle phase de digitalisation pour améliorer le suivi, l’évaluation et la communication autour des projets publics.",
        date: "12 Octobre 2024",
        category: "Innovation",
        author: "Direction des Systèmes d’Information",
        views: 189,
        image: "/assets/images/news/2.jpg"
    },
    {
        id: 9,
        title: "Rencontre avec les acteurs du secteur privé",
        summary:
            "Une rencontre stratégique a été organisée avec les acteurs du secteur privé afin de renforcer la synergie autour des investissements structurants.",
        date: "25 Septembre 2024",
        category: "Concertation",
        author: "CNTIPPEE",
        views: 76,
        image: "/assets/images/news/2.jpg"
    }
];
